const EMAIL_VERIFICATION_ERROR = 'verify_email'
const EMAIL_VERIFICATION_PREFIX = `${EMAIL_VERIFICATION_ERROR}:`

export function isEmailVerificationError(
  description: unknown,
): description is string {
  return (
    typeof description === 'string' &&
    (description === EMAIL_VERIFICATION_ERROR ||
      description.startsWith(EMAIL_VERIFICATION_PREFIX))
  )
}

export function getEmailVerificationEmail(
  description: unknown,
): string | undefined {
  if (!isEmailVerificationError(description)) return undefined

  try {
    return (
      decodeURIComponent(description.slice(EMAIL_VERIFICATION_PREFIX.length)) ||
      undefined
    )
  } catch {
    return undefined
  }
}
